<template lang="html" src="./CompaniesRegistered.html">

</template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      companies: [],
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      search: ""
    };
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function () {
      this.getCompaniesRegistered()
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getCompaniesRegistered();
    },
    disableCompany(id) {
      const vm = this;
      vm.axios
        .put(
          `${vm.$store.state.filooServer}admin/companies/${id}/inactivate`, null,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.$nextTick(() => {
                vm.removeFocus();
            });
            vm.$nextTick(() => {
                vm.getCompaniesRegistered();
            });
          }
        });
    },
    enableCompany(id) {
      const vm = this;
      vm.axios
        .put(
          `${vm.$store.state.filooServer}admin/companies/${id}/active`, null,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.$nextTick(() => {
                vm.removeFocus();
            });
            vm.$nextTick(() => {
                vm.getCompaniesRegistered();
            });
          }
        });
    },
    getCompaniesRegistered() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            `admin/companies?search=${vm.search}&page=${vm.currentx - 1}&size=10&sort=id,desc`,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.fillCompanies();
          }
        });
    },
    fillCompanies() {
      const vm = this;
      for (let c in this.companies) {
         if(this.companies[c].countEmployees > 0) {
          this.companies[c].employees = this.companies[c].countEmployees + " funcionário(s)";
        }else{
          this.companies[c].employees = "Nenhum registro";
        }
        if(this.companies[c].countDependentsActive > 0){
          this.companies[c].dependents = this.companies[c].countDependentsActive + " dependente(s)";
        }else{
          this.companies[c].dependents = "Nenhum registro";
        }
        if(this.companies[c].countActiveHolders > 0){
          this.companies[c].activeHolders = this.companies[c].countActiveHolders + " funcionário(s)";
        }else{
          this.companies[c].activeHolders = "Nenhum registro";
        }
        if (vm.companies[c].active == true) {
          vm.companies[c].status = "Ativa";
        } else {
          vm.companies[c].status = "Inativa";
        }
      }
    },
    removeFocus() {
      document.activeElement.blur()
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    handleSearch(search) {
      this.search = search
      this.getCompaniesRegistered()
    }
  }
};
</script>
<style src="./CompaniesRegistered.css">
</style>
